export interface IUserContactsServiceProvider {
  searchContacts(req: IUuidRequest): Promise<IUserContactResponse>;
  createContact(req: IUserContactCreateRequest): Promise<IUserContactResponse>;
  deleteContact(req: IUserContactRequest): Promise<IUserContactResponse>;
  setContactMain(req: IUserContactRequest): Promise<IUserContactResponse>;
}

interface IUuidRequest {
  id?: string | null;
}

export interface IUserContactResponse {
  phone?: IUserContact[] | null;
  email?: IUserContact[] | null;
}

export interface IUserContact {
  id?: string | null;
  type?: CONTACT_TYPE | null;
  value?: string | null;
  isVerified?: boolean | null;
  isMain?: boolean | null;
  isDeleted?: boolean | null;
}

export enum CONTACT_TYPE {
  UNDEFINED_CONTACT_TYPE = 0,
  MOBILE = 1,
  EMAIL = 2,
  TELEGRAM = 3,
  WHATSAPP = 4,
  FACEBOOK = 5,
  VK = 6,
  OK = 7,
  INSTAGRAM = 8,
  YOUTUBE = 9,
  TWITTER = 10,
  MY_MAIL = 11,
  LINKED_IN = 12,
}

interface IUserContactCreateRequest {
  userId?: string | null;
  contact?: IUserContactCreate | null;
}

interface IUserContactCreate {
  type?: CONTACT_TYPE | null;
  value?: string | null;
}

interface IUserContactRequest {
  userId?: string | null;
  contactId?: string | null;
}
